const translations = {
    addressLineOne: 'Address Line 1',
    addressLineTwo: 'Address Line 2',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code'
};

export default translations;
